// extracted by mini-css-extract-plugin
export default {"annotation":"Annotation-module__annotation--Yrjqb","annotationSource":"Annotation-module__annotationSource--bihTp","annotationMessage":"Annotation-module__annotationMessage--mcXGL"};